export const allTypePolicies = [require('./presentation')];
